import {ApplicationDto} from "./application.dto";
import {ConfigLevel} from "./interfaces/config-level";
import {ConfigLevelType} from "./enums/config-level-type.enum";
import {TreeNode} from "./interfaces/tree-node";
import {Serialisable} from "../serialisable";

export class DashboardTerminalDto extends Serialisable implements ConfigLevel {
    id: number;
    name: string;
    machineName: string;
    displayName: string;
    getDisplayName(): string {
        return this.displayName;
    }
    latestHeartbeatDateUtc: number;
    branchId: number;
    branchName: string;

    applications: ApplicationDto[];

    minVersion: string;
    maxVersion: string;

    canUseCloudDeployments: boolean;

    configLevel = ConfigLevelType.Terminal;
    getChildren(): TreeNode[] {
        return this.applications;
    }
    setChildren(value: ApplicationDto[]): void {
        this.applications = value;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/dashboard-terminal.dto.ts